import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const EmailListSpan = styled.span`
    color: ${Color.Grey.G80}
`;

export const FirstEmailOnlySpan = styled.span`
    font-size: 12px !important;
    white-space: nowrap;
`;
